/**
 * Run date on which the pipeline switched to the combined "new model" output.
 * Runs on or after this date expose Forecast Model / New Model (Combined);
 * older runs expose the legacy four-model breakdown.
 *
 * Single source of truth — change it here, not in each component.
 */
export const NEW_MODEL_FORMAT_RUN_DATE = '20260106';

/** Compact YYYYMMDD -> integer, or null when not a valid compact date */
function toCompactInt(value) {
  const s = String(value || '').trim();
  if (!/^\d{8}$/.test(s)) return null;
  return parseInt(s, 10);
}

/** Split a `YYYYMMDD_YYYYMMDD` (modelDate_runDate) folder name into its parts */
export function parseFolderName(folderName) {
  const parts = String(folderName || '').trim().split('_');
  if (parts.length !== 2) return null;
  const modelDate = toCompactInt(parts[0]) === null ? null : parts[0].trim();
  const runDate = toCompactInt(parts[1]) === null ? null : parts[1].trim();
  if (!modelDate || !runDate) return null;
  return { modelDate, runDate };
}

/**
 * True when a folder's run date is on or after the new-model cutoff.
 * Accepts a `modelDate_runDate` folder name, or a bare compact run date.
 */
export function isNewModelFormatFolder(folderName, cutoff = NEW_MODEL_FORMAT_RUN_DATE) {
  const cutoffInt = toCompactInt(cutoff);
  if (cutoffInt === null) return false;

  const parsed = parseFolderName(folderName);
  const runDate = parsed ? parsed.runDate : String(folderName || '').trim();
  const runInt = toCompactInt(runDate);
  if (runInt === null) return false;

  return runInt >= cutoffInt;
}
